import { action } from 'typesafe-actions';

import * as Constants from './constants';
import * as Types from './types';

export const Language = {
  change: (args: Types.IAction.Language.Change) => action(Constants.LANGUAGE.CHANGE, args)
};

export const Settings = {
  request: (args?: Types.IAction.Settings.Request) => action(Constants.SETTINGS.REQUEST, args),
  success: (args: Types.IAction.Settings.Success) => action(Constants.SETTINGS.SUCCESS, args),
  failure: (args: Types.IAction.Settings.Failure) => action(Constants.SETTINGS.FAILURE, args)
};